import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SaveIcon from "@mui/icons-material/Save";
import { blue } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

import template1 from "../../images/template1.png";
import template2 from "../../images/template2.png";
import template3 from "../../images/template3.png";
import template4 from "../../images/template4.png";
import template5 from "../../images/template5.png";
import Header2 from "../../Component/Header2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const UpdateShopkeeperForm = () => {
  const [shopkeeper, setShopkeeper] = useState({
    shopname: "",
    owner: "",
    address: "",
    contactNumber: "",
    whatsapp: "",
    rmContact: "",
    email: "",
    username: "",
    password: "",
    selectedTemplate: "",
  });

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [loading, setLoading] = useState(false);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const shopkeeperId = localStorage.getItem("shopkeeperID");
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const templates = [
    { name: "template1", image: template1 },
    { name: "template2", image: template2 },
    { name: "template3", image: template3 },
    { name: "template4", image: template4 },
    { name: "template5", image: template5 },
  ];

  useEffect(() => {
    axios
      .get(`https://sakhisshop.com/api/shops/${shopkeeperId}`)
      .then((res) => setShopkeeper(res.data))
      .catch(() =>
        setToast({
          open: true,
          message: "Failed to load profile.",
          severity: "error",
        }),
      );
  }, [shopkeeperId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShopkeeper((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendOtp = async () => {
    try {
      await axios.post(
        ` https://sakhisshop.com/api/email-verification/send-otp?email=${shopkeeper.email}`,
      );
      setToast({
        open: true,
        message: "📨 OTP sent to your email!",
        severity: "info",
      });
      setOtpSent(true);
    } catch {
      setToast({
        open: true,
        message: "❌ Failed to send OTP.",
        severity: "error",
      });
    }
  };

  const handleVerifyOtp = async () => {
    try {
      await axios.post(
        `https://sakhisshop.com/api/email-verification/verify-otp?email=${shopkeeper.email}&otp=${otp}`,
      );
      setOtpVerified(true);
      setToast({
        open: true,
        message: "✅ OTP Verified!",
        severity: "success",
      });
    } catch {
      setToast({
        open: true,
        message: "❌ Invalid or expired OTP.",
        severity: "error",
      });
    }
  };

  //   const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!otpVerified) {
  //     setToast({
  //       open: true,
  //       message: "⚠️ Please verify OTP before updating profile!",
  //       severity: "warning",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   const formData = new FormData();
  //   formData.append(
  //     "shopkeeper",
  //     new Blob([JSON.stringify(shopkeeper)], { type: "application/json" })
  //   );

  //   try {
  //     const res = await axios.put(
  //       `https://sakhisshop.com/api/shops/update/${shopkeeperId}`,
  //       formData,
  //       { headers: { "Content-Type": "multipart/form-data" } }
  //     );
  //     setToast({ open: true, message: "✅ Profile updated successfully!", severity: "success" });
  //     setTimeout(() => window.location.reload(), 2000);
  //   } catch (error) {
  //     console.error("❌ Update error:", error.response?.data || error.message);
  //     setToast({ open: true, message: "❌ Update failed.", severity: "error" });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otpVerified) {
      setToast({
        open: true,
        message: "⚠️ Please verify OTP before updating profile!",
        severity: "warning",
      });
      return;
    }

    setLoading(true);

    // Create a copy of shopkeeper data
    const shopkeeperData = { ...shopkeeper };

    // Remove password if empty
    if (!shopkeeperData.password) delete shopkeeperData.password;

    const formData = new FormData();
    formData.append(
      "shopkeeper",
      new Blob([JSON.stringify(shopkeeperData)], { type: "application/json" }),
    );

    if (photo) {
      formData.append("photo", photo); // ✅ append photo safely
    }

    try {
      const res = await axios.put(
        `https://sakhisshop.com/api/shops/update/${shopkeeperId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      setToast({
        open: true,
        message: "✅ Profile updated successfully!",
        severity: "success",
      });
      setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      console.error("❌ Update error:", error.response?.data || error.message);
      setToast({ open: true, message: "❌ Update failed.", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const userId =
      storedUser?.id ||
      storedUser?.userId ||
      (localStorage.getItem("userId")
        ? Number(localStorage.getItem("userId"))
        : null) ||
      (shopkeeperId ? Number(shopkeeperId) : null);

    if (!userId) {
      setToast({
        open: true,
        message: "Unable to find account id. Please login again and retry.",
        severity: "error",
      });
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete your account? This action cannot be undone.",
    );
    if (!confirmed) return;

    try {
      setIsDeleting(true);
      const token = localStorage.getItem("token");
      await axios.delete(
        `https://sakhisshop.com/api/users/delete-account/${userId}`,
        { headers: token ? { Authorization: `Bearer ${token}` } : {} },
      );

      localStorage.clear();
      setToast({
        open: true,
        message: "✅ Your account has been deleted successfully.",
        severity: "success",
      });
      setTimeout(() => navigate("/MyAccountSignIn"), 1500);
    } catch (error) {
      console.error("Delete account failed:", error);
      setToast({
        open: true,
        message: "❌ Failed to delete account. Please try again.",
        severity: "error",
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Container maxWidth="sm" disableGutters>
      <Header2 />
      <Box px={isMobile ? 1 : 3} py={3}>
        <Box
          sx={{
            p: isMobile ? 2 : 4,
            backgroundColor: "#ffffff",
            boxShadow: 4,
            borderRadius: 4,
            mt: 1,
          }}
        >
          <Typography
            variant={isMobile ? "h6" : "h5"}
            align="center"
            fontWeight={600}
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: blue[700],
              mb: 3,
              py: 4,
            }}
          >
            <IconButton onClick={() => navigate(-1)} color="success">
              <ArrowBackIosNewIcon fontSize="large" />
            </IconButton>
            🏪 Update Shop Profile
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {[
                { label: "Shop Name", name: "shopname" },
                { label: "Owner Name", name: "owner" },
                { label: "Address", name: "address" },
                { label: "Contact Number", name: "contactNumber" },
                { label: "WhatsApp", name: "whatsapp" },
                { label: "rmContact", name: "rmContact" },
                { label: "Email", name: "email" },
                { label: "Username", name: "username" },
                { label: "Password", name: "password", type: "password" },
              ].map((field) => (
                <Grid item xs={12} key={field.name}>
                  <TextField
                    fullWidth
                    size="small"
                    label={field.label}
                    name={field.name}
                    type={field.type || "text"}
                    value={shopkeeper[field.name]}
                    onChange={handleChange}
                    sx={{ backgroundColor: "#fdfdfd" }}
                  />
                </Grid>
              ))}

              {/* OTP Section */}
              <Grid item xs={12}>
                {!otpSent ? (
                  <Button fullWidth variant="outlined" onClick={handleSendOtp}>
                    📤 Send OTP to Email
                  </Button>
                ) : (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      label="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      sx={{ mb: 1, backgroundColor: "#fdfdfd" }}
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleVerifyOtp}
                      disabled={otpVerified}
                    >
                      {otpVerified ? "✅ OTP Verified" : "Verify OTP"}
                    </Button>
                  </>
                )}
              </Grid>

              {/* Template Selection */}
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => setTemplateDialogOpen(true)}
                >
                  {shopkeeper.selectedTemplate
                    ? `Selected Template: ${shopkeeper.selectedTemplate}`
                    : "Select Invoice Template"}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  color="secondary"
                  onClick={() => navigate("/DeliveryBoyRegistration")}
                >
                  🚚 Create Delivery Boy
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  color="success"
                  onClick={() => navigate("/EmployeeRegistration")}
                >
                  👨‍💼 Create Employee
                </Button>
              </Grid>
              <Grid item xs={12} sx={{ mt: 1 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={!loading && <SaveIcon />}
                  sx={{
                    fontWeight: 600,
                    py: 1.2,
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    "Update Profile"
                  )}
                </Button>
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 2,
                    pt: 2,
                    borderTop: "1px solid #eee",
                  }}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    align="center"
                    sx={{ mb: 1.5 }}
                  >
                    Deleting your account is permanent and cannot be undone.
                  </Typography>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="error"
                    size="large"
                    startIcon={!isDeleting && <DeleteOutlineIcon />}
                    sx={{
                      fontWeight: 600,
                      py: 1.2,
                      borderRadius: 2,
                      textTransform: "none",
                      borderWidth: 2,
                      "&:hover": { borderWidth: 2 },
                    }}
                    onClick={handleDeleteAccount}
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <CircularProgress size={22} color="error" />
                    ) : (
                      "Delete Account"
                    )}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>

      {/* Toast */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={toast.severity}
          variant="filled"
          onClose={() => setToast({ ...toast, open: false })}
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>

      {/* Template Dialog */}
      <Dialog
        open={templateDialogOpen}
        onClose={() => setTemplateDialogOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Select Your Invoice Template
          <IconButton
            onClick={() => setTemplateDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {templates.map((template) => (
              <Grid item xs={12} sm={6} md={4} key={template.name}>
                <Box
                  component="img"
                  src={template.image}
                  alt={template.name}
                  onClick={() => {
                    setShopkeeper((prev) => ({
                      ...prev,
                      selectedTemplate: template.name,
                    }));
                    setTemplateDialogOpen(false);
                  }}
                  sx={{
                    width: "100%",
                    height: 180,
                    objectFit: "cover",
                    cursor: "pointer",
                    border:
                      shopkeeper.selectedTemplate === template.name
                        ? "3px solid #1976d2"
                        : "2px solid #ccc",
                    borderRadius: 2,
                    transition: "0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                      boxShadow: 4,
                    },
                  }}
                />
                <Typography align="center" mt={1}>
                  {template.name}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTemplateDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default UpdateShopkeeperForm;
